type MessageProps = {
  message?: string | null;
  error?: string | null;
  html?: boolean;
};

const Message = ({ message, error, html }: MessageProps) =>
  html ? (
    <div dangerouslySetInnerHTML={{ __html: error || '' }} className="text-red-500 font-bold text-lg"></div>
  ) : (
    <>
      {error && <div className="text-red-500 font-bold text-lg">{error}</div>}
      {message && <div className="text-green-700 font-bold text-lg">{message}</div>}
    </>
  );

export default Message;
